import styled, { keyframes } from 'styled-components'

export const INFTCreateModalWrapper = styled.div`
  width: 100%;
  padding: 1rem;
`

export const NFTCreateModalHead = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  display: flex;

  .title {
    font-weight: bold;
    font-size: 1.5rem;
    width: 100%;
  }

  .close {
    width: 25px;
    height: 25px;
    border: solid 1px ${({ theme }) => theme.text1};
    border-radius: 50%;
    display: block;
    text-align: center;
    cursor: pointer;
  }
`

export const NFTCreateModalButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const pendingAnimation = keyframes`
  0% {
    background: #3D5A80;
  }

  20% {
    background: #FF6871;
  }

  40% {
    background: #27AE60;
  }

  60% {
    background: #EE6C4D;
  }

  80% {
    background: #98C1D9;
  }

  100% {
    background: #3D5A80;
  }
`

export const NFTCreateModalButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 1rem;
  }

  .button-head {
    display: flex;

    .button-status {
      margin-right: 1rem;
    }

    .button-text {
      width: 100%;
      margin-bottom: 0.3rem;

      .button-title {
        font-weight: bold;
        font-size: 1.1rem;
        margin-bottom: 0.5rem;
      }

      .button-description {
        font-size: 0.9rem;
        color: ${({ theme }) => theme.text2};
      }
    }
  }

  .button {
    display: flex;
    justify-content: center;

    button {
      width: 100%;
      text-align: center;
      background: ${({ theme }) => theme.bg6};
      color: #fff;
      padding: 0.5rem;
      margin-top: 0.5rem;
      font-weight: bold;
      cursor: pointer;
      user-select: none;
      outline: none;
      border: none;

      :hover {
        background: ${({ theme }) => theme.bg7};
      }

      &.disabled {
        background: ${({ theme }) => theme.bg6};
        cursor: not-allowed;
        opacity: 0.5;

        :hover {
          background: ${({ theme }) => theme.bg6};
          opacity: 0.5;
        }
      }

      &.pending {
        animation: 4s ${pendingAnimation} linear infinite;
        transition: background ease 2s;
      }
    }
  }
`
